import { render } from "./App.vue?vue&type=template&id=89a397da"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=89a397da&lang=scss"
const cssModules = {}
import style1 from "./App.vue?vue&type=style&index=1&id=89a397da&lang=scss&module=true"
cssModules["$style"] = style1

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__